import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-triangle",
  "use": "icon-triangle-usage",
  "viewBox": "0 0 5 4",
  "content": "<symbol viewBox=\"0 0 5 4\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-triangle\">\n<path d=\"M2.5 0L4.99998 3H-2.45571e-05L2.5 0Z\" fill=\"lightgray\" />\n<path d=\"M2.50002 0.5L5 3.5H2.38419e-07L2.50002 0.5Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol